import React from "react";
import Avatar from "@material-ui/core/Avatar";
import { contactDisplayName } from "../../utils/contactPresentation";

const ContactAvatar = ({ contact, ...props }) => {
  const name = contactDisplayName(contact);
  const source = contact?.profilePicUrl || undefined;
  const initials = name.split(/\s+/).slice(0, 2).map(part => part[0]).join("").toLocaleUpperCase();
  // Remote WhatsApp image URLs are signed: preserve them exactly. The identity
  // key clears an old image/error when a different contact or photo is loaded.
  return <Avatar key={String(contact?.id || "") + ":" + (source || "")} src={source} alt={name} {...props}>{initials}</Avatar>;
};
export default ContactAvatar;
